import {
  DebtAction,
  DebtState,
  SET_DEBTS,
  SET_DEBTS_LOADED,
  SET_DEBT_FILTER,
  SET_TOTAL_DEBTS,
} from '../types'

const initialState: DebtState = {
  debts: [],
  totalDebts: 0,
  isDebtsLoaded: false,
  debtFilter: {
    pageSize: 15,
    pageIndex: 1,
    cardId: '',
    customerName: '',
    stationName: '',
  },
}

export const debtReducer = (
  state = initialState,
  action: DebtAction
): DebtState => {
  switch (action.type) {
    case SET_DEBTS:
      return {
        ...state,
        debts: action.payload,
      }
    case SET_TOTAL_DEBTS:
      return {
        ...state,
        totalDebts: action.payload,
      }
    case SET_DEBTS_LOADED:
      return {
        ...state,
        isDebtsLoaded: action.payload,
      }
    case SET_DEBT_FILTER:
      return {
        ...state,
        debtFilter: action.payload,
      }
    default:
      return state
  }
}
